/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function IncidentInhibateGlobalLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeIncidentInhibateGlobalLoadedAction }
 *     action: action de l'application
 * @return { Reducer }
 */
export const IncidentInhibateGlobalLoadedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action:
             actionsTypesFromStore.TypeIncidentInhibateGlobalLoadedAction) => {
          switch (action.type) {
            case actions.IncidentInhibateGlobalLoadedActionTypes
                .INCIDENTINHIBATEGLOBALLOADED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.IncidentInhibateGlobalLoadedActionTypes
                .INCIDENTINHIBATEGLOBALLOADED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.IncidentInhibateGlobalLoadedActionTypes
                .INCIDENTINHIBATEGLOBALLOADED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            default:
              return state
              break;
          }
        }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/incident/home/index.ts